/**
 * Cliente HTTP para Cotizaciones persistidas y los Textos del PDF editables.
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const fetchQuotes = (q) => axios.get(`${API}/quotes`, { params: q ? { q } : {} });
export const fetchQuote = (id) => axios.get(`${API}/quotes/${id}`);
export const updateQuote = (id, data) => axios.put(`${API}/quotes/${id}`, data);
export const updateQuoteStatus = (id, status) => axios.put(`${API}/quotes/${id}/status`, null, { params: { status } });
export const deleteQuote = (id) => axios.delete(`${API}/quotes/${id}`);
export const convertQuoteToContract = (id) => axios.post(`${API}/quotes/${id}/convert-to-contract`);

export const fetchPdfTextos = () => axios.get(`${API}/cotizador/pdf-textos`);
export const updatePdfTextos = (data) => axios.put(`${API}/cotizador/pdf-textos`, data);
